import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-votprioverview',
  templateUrl: './votprioverview.component.html',
  styleUrls: ['./votprioverview.component.scss'],
    providers:[MasterService]
})
export class VotprioverviewComponent implements OnInit {

  
      memberdetails:any[]=[];
      classdetails:any[]=[];
      closeResult: string;
      classes: any=[];
      section: any=[];
    
      objclass:any={};
      objsec:any={};
      objcrs:any={};
      arrcourse:any=[]
      boothid:any=0;
      arrvotres:any=[];
      modalOptions:NgbModalOptions;
      private modalRef: NgbModalRef;
  arovrbooth: any=[];
  arovrclass: any=[];
  voteperc: any;
    
      constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
    
      open(content) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return `with: ${reason}`;
        }
      }
    
    
    
      ngOnInit(): void {
        
        this.selbooth();
        // this.selpost();
      }
    
    
      selbooth() {
        this.mservice.sel_booth()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.classes = resultArray;
                this.boothid=this.classes[0].boothid;
               this.votoverview();
            },
            error => console.log("Error :: " + error)
            )
      }

        votoverviewbooth() {
        this.mservice.votoverviewbooth()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arovrbooth = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }


        votoverviewclass() {
        this.mservice.votoverviewclass()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arovrclass = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }


      votoverview() {
        this.mservice.votoverview(this.boothid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrvotres = resultArray.arrres;
                this.voteperc=resultArray.voteperc;
                this.votoverviewbooth();
                this.votoverviewclass();
               // this.boothid=this.classes[0].boothid;
                // this.boothid=this.classes[0].boothid;
               
            },
            error => console.log("Error :: " + error)
            )
      }
    
      private getcourses() {
    
        this.mservice.getcourse()
      .subscribe((result:any) => {
      
      this.arrcourse=result;
      
      
      
      }, error => {
      
      //alert('error in r');
      // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
      }
      );
        
        
      }
    
      openclass(content,objdata,cmd) {
        if(cmd=='insert')
        {
          this.objclass={};
         
          
          this.objclass.boothid=0;
          this.objclass.sortid=1;
         
          this.objclass.oprtype='ins';
         
    
        }
    
        else if(cmd=='update')
        {
          this.objclass=objdata;
          this.objclass.oprtype='upd';
        }
        
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'sm'
         
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
      
      opensec(content,objdata,cmd) {
        if(cmd=='insert')
        {
          this.objsec={};
         
          
          this.objsec.postid=0;
           this.objsec.sortid=0;
         
          this.objsec.oprtype='insert';
         
    
        }
    
        else if(cmd=='update')
        {
          this.objsec=objdata;
          this.objsec.oprtype='upd';
        }
        
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'sm'
         
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
    
      opencrs(content,objdata,cmd) {
        if(cmd=='insert')
        {
          this.objcrs={};
         
          
          this.objcrs.crid=0;
         
          this.objcrs.oprtag='insert';
         
    
        }
    
        else if(cmd=='update')
        {
          this.objcrs=objdata;
          this.objcrs.oprtag='update';
        }
        
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'sm'
         
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
    
      savemascourse()
      {
    
    
       // console.log('savedetails',this.objcrs);
        this.mservice.savemascourse(this.objcrs)
    .subscribe(result => {
       alert(result.message);
       
    if(result.status=='success')
    {
      let localmodref=this.modalRef;
    localmodref.close();
    //this.Refreshsummary();
    this.getcourses();
    
    }
    
    
    else{
    
    
    }
       
    
      
        
    }, error => alert('error in connection')
    );
      }
      savebooth()
      {
    
    
        console.log('save_booth',this.objclass);
        this.mservice.save_booth(this.objclass)
    .subscribe(result => {
       alert(result.message);
       
    if(result.status=='success')
    {
      let localmodref=this.modalRef;
    localmodref.close();
    //this.Refreshsummary();
    this.selbooth ();
    
    }
    
    
    else{
    
    
    }
       
    
      
        
    }, error => alert('error in connection')
    );
      }
    
      selpost() {
        this.mservice.sel_posts()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.section = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }
      
      savepost()
      {
    
    
        console.log('savedetails',this.objsec);
        this.mservice.save_posts(this.objsec)
    .subscribe(result => {
       alert(result.message);
       
    if(result.status=='success')
    {
      let localmodref=this.modalRef;
    localmodref.close();
    //this.Refreshsummary();
    this.selpost();
    
    }
    
    
    else{
    
    
    }
       
    
      
        
    }, error => alert('error in connection')
    );
      }


       printform(boothid){
         debugger;
           var clcd=localStorage.getItem('clcd');
           var aycd=localStorage.getItem('aycd');
          
            var url=this.mservice.callurl+"export/exp_voteres.php?clcd="+clcd+"&aycd="+aycd+"&boothid="+boothid;
            window.open(url,'','');
          } 
     
      // SaveclassDetails()
      // {
      //     debugger
      // //alert ('hi');
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');
      // var clid = this.model.clid;
      // var clname = this.model.clname;
      // var clcode = this.model.clcode;
      // //var fyear = this.user.fyear;
      // var clsdata ={clid:clid, clname:clname,scode:clcode,fyear:clcode,clcd:clcd,aycd:aycd};
      
      // //console.log(f.value.clcode);
      // //this.closeModal();
      // this.model=f.value;
      
      // this.model.clcd=clcd;
      // this.model.aycd=aycd;
      // console.log('model',this.model);
      // this.SService.saveclassdtls(this.model)
      // .subscribe(result => {
      //     console.log('ret',JSON.stringify(result));
      //     alert (result.message);
      //     //this.alertmessage=result.message;
      
      // this.Getclasslist();
      // }, error => 
      // alert('error in connection')
      // //this.alertmessage='error in connection'
      // );
      
      // this.closeAddExpenseModal.nativeElement.click();
      
      // }
    
     
    }
    